import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'vehicle-seal-inscan',
  components: {
    VueElementLoading,
    BasicSelect,
    DatePicker,
  },
  props: [],
  data() {
    return {
      isLoading: false,
      tripno: '',
      fullconnectionname: '',
      currenttouchpoint: '',
      touchpointlist: [],
      touchpointlistitem : {},
      touchPointHubId: '',
      step: 1,
      vecInScantime : '',
      schedulecreateddate: '',
      inscanDateTimeRange: '',
      ticketno: '',
      TripIdError: '',
      useremail: '',
      inputPayload: '',
      connectiondestinationhubid: '',

    }
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail[0].email;
  },
  methods: {
    
    getTripDetails() {

      if (this.tripno == '') {
        this.TripIdError = 'The Trip Id field is required.'
      } else {
        this.TripIdError = ''
        this.vecInScantime = ''
        this.isLoading = true
        this.touchpointlist = [];
        this.fullconnectionname='';
        this.currenttouchpoint = '';
        this.schedulecreateddate = '';
        this.ticketno = '';
        this.touchpointlistitem='';
        this.touchPointHubId='';
        
        this.$validator.reset();

        axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'searchTrip?tripId=' + this.tripno + '&createdBy=' + this.useremail,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
          .then(result => {
            this.isLoading = false
            if (result.data.ResultCode == 100) {

              var tripResponse = result.data.ResponseData[0];

              var apiPayload = {
                "csmid" : tripResponse.connectionschedulemasterid,
                "connectionid" : tripResponse.connectionid,
                "invoiceno" : tripResponse.invoiceno,
                "routeMode" : tripResponse.routemode,
                "createdBy" : this.useremail
              };
              
              this.inputPayload = apiPayload;
              this.fullconnectionname = tripResponse.fullconnectionname;
              this.currenttouchpoint = tripResponse.currenthubname;
              this.schedulecreateddate = tripResponse.currenttime;
              this.connectiondestinationhubid = tripResponse.connectiondestinationhubid;

              var date = new Date(this.schedulecreateddate);
              this.inscanDateTimeRange = date.setDate(date.getDate() - 1);
              tripResponse.touchPoints.map(obj => {
                this.touchpointlist.push({
                  "value": obj.hubid,
                  "text": obj.hubname + '(' + obj.hubid + ')'
                });
              });

              this.$alertify.success(result.data.ReturnMessage);

            } else {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoading = false
            console.error(error)
          })
      }
    },
    selectTouchPoint(item) {    

			this.touchpointlistitem = item;
			this.touchPointHubId = this.touchpointlistitem.value;

		},
    ScanIn(){

      if(this.connectiondestinationhubid == this.touchPointHubId)
      {
        this.$alertify.error('Selected touchpoint cannot be destintion');
        return;
      }

      this.inputPayload.inScanTouchPointhubId = this.touchPointHubId;
      this.inputPayload.ticketno = this.ticketno;
      this.inputPayload.createdDate = this.vecInScantime;

        this.isLoading = true
          axios({
            'method': 'POST',
            'url': apiUrl.api_url_hubops + 'logVehicleInscan',
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25',
            },
            'data' : this.inputPayload,
          })
            .then(result => {
              this.isLoading = false
              if (result.data.ResultCode == 100) {
                this.$alertify.success(result.data.ReturnMessage);
              } else {
                this.$alertify.error(result.data.ReturnMessage)
              }
            }, error => {
              this.isLoading = false
              console.error(error)
            })    
    },
    
    onsubmit(){
      
      this.$validator.validateAll().then((result) => {
				if(result){
					this.ScanIn();
					event.target.reset();
				}else{
					this.isLoading = false;
				}
			}).catch(() => {
			  this.isLoading = false;
			  this.$alertify.error('Error Occured');
			});
    },
    resetForm() {
      this.isLoading = false
      this.tripno = ''
      this.TripIdError = ''
      this.fullconnectionname = ''
      this.touchpointlist = []
      this.currenttouchpoint = ''
      this.touchpointlistitem = ''
      this.vecInScantime = ''
      this.ticketno = ''
      this.touchPointHubId = ''
      this.schedulecreateddate = ''
      this.inscanDateTimeRange = ''
      this.$validator.reset();
			this.errors.clear();

    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/VehicleSealInScan/VehicleSealInScan.js